<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { useLocaleStore } from './stores/locale'

// Initialize locale store inside a component setup — usePrimeVue() requires
// component context and fails when called from top-level main.ts.
const localeStore = useLocaleStore()
onMounted(() => {
  localeStore.initialize()
})
</script>

<template>
  <Toast position="top-right" />
  <ConfirmDialog />
  <RouterView />
</template>

<style lang="scss">
#app {
  min-height: 100vh;
}
</style>
